module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/farming-agriculture-c110a4640044df3eea7a6aac85544b02.png";